import Text from 'components/common/Text';
import { LabelsContext, ThemeContext } from 'helpers/contexts';
import React, { useContext } from 'react';
import { FormContainer, Img, MobileContentContainer, MobileHeadlineContainer } from '../style';
import * as S from './style';
import * as Constant from 'constant';
import FireberryLogo from 'images/FireberryLogo.png';
import { TextInput } from 'components/common/Input';
import Button from 'components/common/Button';
import LoadingButton from 'components/common/LoadingButton';
import Icon from 'components/common/Icon';

function MobileTemplateAndCompanySize(props) {
  const { colors } = useContext(ThemeContext);
  const { signUp, global } = useContext(LabelsContext);
  const companySizeErrorMessageTop = props.isRtl ? '122px' : '145px';

  const handleChipClick = (value) => {
    props.onChipSelection && props.onChipSelection(value);
  };

  const handleBusinessTypeSelect = (value) => {
    props.onBusinessTypeChange && props.onBusinessTypeChange(value);
  };

  return (
    <S.MobileTemplateAndCompanySizePageContainer bgColor={colors.white}>
      <MobileHeadlineContainer>
        <Img src={FireberryLogo} width={'210px'} />
      </MobileHeadlineContainer>
      <FormContainer>
        <MobileContentContainer>
          <S.IndustryTypeContainer>
            <Text size={Constant.SIZE.xxl}>{signUp.templateAndCompanySize.industryType}</Text>
            <S.IndustrySelectInputContainer isRtl={props.isRtl} borderColor={colors.gray.gray400}>
              {props.businessTypes.map((businessType) => {
                const isSelected = props.businessType === businessType.value;
                const buttonColor = isSelected ? colors.gray.gray400 : colors.gray.gray200;
                return (
                  <S.BusinessTypeContainer key={businessType.value}>
                    <S.BusinessTypeButton
                      data-tid={`signup.secondscreen.businesstemplate.${businessType.value}`}
                      color={buttonColor}
                      hoverColor={colors.gray.gray300}
                      onClick={() => handleBusinessTypeSelect(businessType.value)}
                      padding={businessType.padding}
                      iconTextMargin={props.shouldShowIcons ? businessType.iconTextMargin : undefined}
                    >
                      {props.shouldShowIcons && <Icon size={Constant.SIZE.xl} color={colors.gray.charcoal} name={businessType.icon}></Icon>}
                      <Text size={Constant.SIZE.xl} color={colors.gray.charcoal}>
                        {businessType.label}
                      </Text>
                    </S.BusinessTypeButton>
                  </S.BusinessTypeContainer>
                );
              })}
            </S.IndustrySelectInputContainer>
            {props.businessTypeError && (
              <S.ErrorContainer bottom={'-9%'}>
                <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                  {props.businessTypeError}
                </Text>
              </S.ErrorContainer>
            )}
          </S.IndustryTypeContainer>
          <S.CompanySizeContainer>
            <Text size={Constant.SIZE.xxl}>{signUp.templateAndCompanySize.companySize}</Text>
            <S.MobileChipContainer>
              {props.companySizeOptions.map((option) => {
                return (
                  <S.CompanySizeWrapper data-tid={`signup.secondscreen.companysize.${option.label}`} key={option.value}>
                    <Button
                      size={Constant.SIZE.large}
                      text={option.label}
                      color={Constant.COLOR.light}
                      variant={Constant.VARIENT.outlined}
                      onClick={() => handleChipClick(option.value)}
                      isActive={props.companySize === option.value}
                      rounded
                    />
                  </S.CompanySizeWrapper>
                );
              })}
            </S.MobileChipContainer>
            {props.companySizeError && (
              <S.ErrorContainer top={companySizeErrorMessageTop} bottom={'-5%'}>
                <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                  {props.companySizeError}
                </Text>
              </S.ErrorContainer>
            )}
          </S.CompanySizeContainer>
          <S.InputContainer>
            <Text size={Constant.SIZE.xxl}>{signUp.templateAndCompanySize.companyName}</Text>
            <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.secondscreen.companyname'}>
              <TextInput
                size={Constant.SIZE.large}
                width={Constant.FULL_LENGTH}
                value={props.companyName}
                variant={Constant.VARIENT.empty}
                onChange={props.onCompanyNameChange}
              />
            </S.InputWrapper>
            {props.companyNameError && (
              <S.ErrorContainer isRtl={props.isRtl} bottom={'-30%'}>
                <Text size={Constant.SIZE.xxs} color={colors.red.salmon}>
                  {props.companyNameError}
                </Text>
              </S.ErrorContainer>
            )}
          </S.InputContainer>
          <S.SubmitButtonContainer data-tid={'signup.secondscreen.letsgobutton'} marginTop={'40px'}>
            <LoadingButton
              id={'step2'}
              size={Constant.SIZE.xl}
              color={Constant.COLOR.dark}
              onClick={props.onSubmit}
              text={global.letsGo}
              rounded
              isLoading={props.isUpdating}
              width={'100%'}
            />
          </S.SubmitButtonContainer>
        </MobileContentContainer>
      </FormContainer>
    </S.MobileTemplateAndCompanySizePageContainer>
  );
}

export default MobileTemplateAndCompanySize;
